export const blockIconsPhotoandimageAutoStoriesNew = (
	<span className='material-symbols-outlined'>auto_stories</span>
);
